module.exports = __webpack_public_path__ + "img/FAQ-on.2daa0fbc.png";